import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getInitialLocale } from './routing';

// Import translations
import enCommon from './translations/en/common.json';
import esCommon from './translations/es/common.json';
import deCommon from './translations/de/common.json';
import ukCommon from './translations/uk/common.json';

const resources = {
  en: {
    common: enCommon
  },
  es: {
    common: esCommon
  },
  de: {
    common: deCommon
  },
  uk: {
    common: ukCommon
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLocale(),
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
